module.exports = __webpack_public_path__ + "assets/avatar_upload_placeholder.png";